module.exports = __webpack_public_path__ + "static/media/queretaro.98b686ca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/centers/queretaro.png
// module id = 626
// module chunks = 0